export enum HospitalCountry {
  KR = 'KR',
  JP = 'JP',
}
